import { PLATE_FIELD_TYPE } from 'reusable/Dialog/dialogInterface';

export const allVehicleSortingOptions = (t: Function) => [
  // 『既定』はサーバーの既定の並び（新しい順）。vehicles に check_in は無い。
  { label: t('sort.default', { ns: 'common' }), value: '' },
  { label: t('sort.plate-number', { ns: 'common' }), value: 'plate_number' },
  // A07（2026-11-03 和田様の UAT）。車種の順。
  { label: t('sort.car-model', { ns: 'common' }), value: 'car_model' },
];

// A07（2026-11-03 和田様の UAT）。ナンバーは地名・分類番号・ひらがな・一連番号の4つの欄で入れ、
// 「品川 330 な 38-59」に組み立てて plate_number に入れる（reusable/PlateNumberInput）。
// 車種の候補（同じ会社で過去に入れた車種）は AllVehicleManagement が suggestions で足す。
export const addVehicleFields = (t: Function, data: any = {}) => [
  {
    label: t('all-vehicle.add-vehicle.plate-number', { ns: 'vehicle' }),
    type: PLATE_FIELD_TYPE,
    name: 'plate_number',
    isRequired: true,
  },
  {
    label: t('all-vehicle.add-vehicle.truck-model', { ns: 'vehicle' }),
    type: 'text',
    name: 'car_model',
    isRequired: true,
  },
];

export const editVehicleFields = (t: Function, data: any = {}) => [
  {
    label: t('all-vehicle.edit-vehicle.plate-number', { ns: 'vehicle' }),
    type: PLATE_FIELD_TYPE,
    name: 'plate_number',
    isRequired: true,
    value: data.plate_number,
  },
  {
    label: t('all-vehicle.edit-vehicle.truck-model', { ns: 'vehicle' }),
    type: 'text',
    name: 'car_model',
    isRequired: true,
    value: data.car_model,
  },
];

export const deleteVehicleFields = (t: Function, data: any = {}) => [
  {
    label: t('all-vehicle.delete-vehicle.plate-number', { ns: 'vehicle' }),
    name: 'plate_number',
    value: data.plate_number,
  },
  {
    label: t('all-vehicle.delete-vehicle.truck-model', { ns: 'vehicle' }),
    name: 'car_model',
    value: data.car_model,
  },
];
